import { Box, Grid, Typography } from "@mui/material";
import { ButtonCore } from "src/Pages/components/ButtonCore/ButtonCore";
import { toAbsoluteUrl } from "src/shared/setup/toAbsoluteUrl";
import { UseFormAbandonment } from "../Hooks/UseFormAbandonment";
import { useEffect, useState } from "react";
import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { getToken } from "src/shared/setup/API/api";

interface DetailsSubscriptionsProps {
  setStep: (step: number) => void;
}

export const DetailsSubscriptions = ({
  setStep,
}: DetailsSubscriptionsProps) => {
  const { handleSubmit } = UseFormAbandonment();
  const { setAuthorization, setUserPerfil } = useAuthContext();
  const [countClick, setCountClick] = useState(0);

  const logout = async () => {
    setCountClick(countClick + 1);
    if (countClick === 3) {
      localStorage.removeItem(getToken);
      setAuthorization(false);
      setUserPerfil(undefined);
    }
  };

  useEffect(() => {
    handleSubmit({ event: "PRESENTATION" });
  }, []);

  return (
    <Grid container height="100%">
      <Grid item xs={12} md={6} sx={{ padding: { xs: "24px", md: "32px" } }}>
        <Box>
          <Typography
            sx={{
              fontWeight: 600,
              mb: { xs: 1.5, md: 2 },
              fontSize: { xs: 20, md: 24 },
              color: "text.primary",
            }}
          >
            Teste o Correctors grátis por 10 dias
          </Typography>

          <Typography
            sx={{
              color: "text.secondary",
              mb: { xs: 2 },
              fontSize: { xs: 14, md: 16 },
            }}
          >
            Chega de perder renovações e se afogar em planilhas! Com o
            Correctors, você centraliza seus contratos, automatiza processos e
            foca nas sua vendas.
          </Typography>

          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 500,
              mb: { xs: 2 },
              fontSize: { xs: 14, md: 16 },
              color: "text.primary",
            }}
          >
            Veja o que o Correctors inclui:
          </Typography>

          <Box
            sx={{
              mb: 2,
              "&  *": {
                fontSize: { xs: 14, md: 16 },
                mb: { xs: 0.8 },
              },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box sx={{ mr: 1 }}>•</Box>
              <Typography>
                <strong>Gestão completa de contratos</strong> Organize e
                controle 100% dos seus contratos em um único lugar — sem
                bagunça, sem planilhas manuais.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box sx={{ mr: 1 }}>•</Box>
              <Typography>
                <strong> Disparo inteligente via WhatsApp</strong> - Envie
                mensagens personalizadas para milhares de clientes com poucos
                cliques
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box sx={{ mr: 1 }}>•</Box>
              <Typography>
                <strong>Inteligência Artificial aliada</strong> - Venda mais com
                o apoio de uma IA pensada para otimizar seus resultados e
                facilitar sua rotina.
              </Typography>
            </Box>
          </Box>

          <Typography sx={{ color: "text.secondary", mb: 2 }}>
            Cancele quando quiser.
          </Typography>

          <ButtonCore
            variant="contained"
            fullWidth
            sx={{ bgcolor: "#8B3DFF", py: 1.4 }}
            title="Começar meu teste grátis"
            onClick={() => setStep(2)}
          />
        </Box>
      </Grid>

      <Grid item md={6} sx={{ height: "100%", position: "relative" }}>
        <Box>
          <ButtonCore
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: 1,
              border: "none",
              maxWidth: "5px",
              boxShadow: "none",
              bgcolor: "rgba(0, 0, 0, 0)",
              "&:hover": {
                bgcolor: "rgba(0, 0, 0, 0)",
                border: "none",
                maxWidth: "5px",
                boxShadow: "none",
                cursor: "default",
              },
            }}
            onClick={logout}
          />
        </Box>
        <Box
          component="img"
          src={toAbsoluteUrl("/media/cena-de-personagem.avif")}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
            display: {
              xs: "none",
              md: "block",
            },
          }}
        />
      </Grid>
    </Grid>
  );
};
